import { PendingSaleOrder } from '@/domain/SaleOrder';
import { Services } from '@/infra/services';

import { baseSaleOrderAdapter } from './adapter';

export async function getPendingSaleOrders() {
  const response = await Services.SaleOrder.getPendingSaleOrders();

  return response.data.map((pendingSaleOrder) => {
    const domainProps = baseSaleOrderAdapter(pendingSaleOrder);

    return new PendingSaleOrder(domainProps, {
      isPayable: pendingSaleOrder.payable,
      paymentUrl: pendingSaleOrder.paymentUrl,
    });
  });
}
